import { IContentItem } from '@kontent-ai/delivery-sdk';
import {
  CacheConfig,
  CacheStatus,
  getCachedItem,
  setCacheItem,
  setCacheStatus,
} from '@r-and-a-shared-ui/core-caching';
import { deliveryClient } from '../config/kontent-delivery-client';
import { mapSeoData } from '../utils';

type Input = {
  input: {
    codename: string;
    cache?: boolean;
    cacheTTL?: number;
  };
  cacheStatus?: CacheStatus;
};

type SeoData = {
  title?: string;
  description?: string;
  keywords?: string;
  noindex?: boolean;
  nofollow?: boolean;
  urlSlug?: string;
};

export const getPageSeoByCodeName = async <Type extends SeoData>({
  input: {
    codename,
    cache = true,
    cacheTTL = CacheConfig.TTL.Config.valueOf(),
  },
  cacheStatus,
}: Input): Promise<Type | undefined> => {
  const cacheKey = `getPageSeoByCodeName-${codename}`;
  try {
    const cachedItem = getCachedItem<Type>(cacheKey, cache);

    if (cachedItem) {
      setCacheStatus(cacheStatus, {
        cacheable: cache,
        xInMemoryCache: CacheConfig.Hit,
        cacheTTL,
      });
      return cachedItem;
    }

    const response = await deliveryClient
      .item<IContentItem>(codename)
      .depthParameter(1)
      .toPromise();

    const responseItem = response?.data?.item;

    const seoData = mapSeoData(responseItem) as Type;

    setCacheItem<Type>(cacheKey, seoData, cacheTTL, cache);

    setCacheStatus(cacheStatus, {
      cacheable: cache,
      xInMemoryCache: CacheConfig.Miss,
      cacheTTL,
    });

    return seoData;
  } catch (error) {
    console.error('Error in getPageSeoByCodeName', error);
    throw error;
  }
};
